import cn from 'classnames';
import useStore from '@/stores/sider-menu';
import LogoBar from './logo-bar';
import NewRequest from './new-request';
import InquiriesNav from './inquiries-nav';
import ReportsNav from './reports-nav';
import RequestList from './requests';
import UserProfile from './user-profile';
import SupplierList from './suppliers';
import { useRequestsUpdate } from './hooks/useRequestsUpdate';
import { useSupplierUpdate } from './hooks/useSupplierUpdate';
interface SiderProps {
  className?: string;
}
export default function Sider({ className }: SiderProps) {
  const { collapsed } = useStore();

  // 菜单相关推送更新
  useRequestsUpdate();
  useSupplierUpdate();

  return (
    <div className={cn(collapsed ? 'w-auto' : 'w-[274px]', 'h-full flex flex-col flex-none')}>
      <div
        className={cn(
          'min-h-0 flex px-1 flex-col flex-1 py-4 m-4 rounded-xl border border-white shadow-[0_25px_50px_-12px_rgba(0,0,0,0.16)] bg-[linear-gradient(164deg,#F7F7F7_54.55%,#F0FAFC_114.76%)]',
          className
        )}
      >
        <LogoBar />
        <div className="relative min-h-0 flex-1 flex flex-col gap-2 pt-4">
          <NewRequest />
          <RequestList />
          <InquiriesNav />
          <ReportsNav />
          <SupplierList />
        </div>
        <UserProfile />
      </div>
    </div>
  );
}
